import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const SidebarShow14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <path
      d='M8.96968 6.96967L10.0303 8.03033L13.0607 5L10.0303 1.96967L8.96968 3.03033L10.9393 5L8.96968 6.96967Z'
      fill='currentColor'
    />
    <path d='M1 3.74999H7V2.24999H1V3.74999Z' fill='currentColor' />
    <path d='M1 7.74999H7V6.24999H1V7.74999Z' fill='currentColor' />
    <path d='M1 11.75V10.25H13V11.75H1Z' fill='currentColor' />
  </Svg>
);

SidebarShow14.displayName = 'SidebarShow14';
export default SidebarShow14;
